import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from "@angular/router";
import { HttpParams } from '@angular/common/http';
import { LOCALE_ID, Inject } from '@angular/core';
import { InternationalPhoneNumberModule } from 'ngx-international-phone-number';
import { NgModule } from '@angular/core';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-wrap-me',
  templateUrl: './wrap-me.component.html',
  styleUrls: ['./wrap-me.component.scss']
})
export class WrapMeComponent implements OnInit {
  loaded: boolean = false;
  wrapMeToken = '';
  username = '';
  profileData = [];
  siteName = environment['name'];
  siteID = environment.siteID;
  counter = 0;
  max = 60;
  isWoohoo: boolean = environment['isWooHoo'];
  intervalManage:any;
  tempPass = '';
  tryAgain: boolean = false;
  failed: boolean = false;
  hideUsername: boolean = false;
  isTrue: boolean = false;
  constructor(@Inject(LOCALE_ID) protected localeId: string, private route: ActivatedRoute, private http: HttpClient, private router: Router, ) { this.checkParams() }
  public checkParams() {
    this.route.params.subscribe(params2 => {
      this.wrapMeToken = params2['wrapMeToken'];
      if (this.wrapMeToken) {
        this.getUserDetails(this.wrapMeToken);
      }
    })
  }
  getUserDetailAgain() {
    console.log('starting timer');
    this.intervalManage = setInterval(() => { this.getUserDetails(this.wrapMeToken); }, 5000);
  console.log(this.intervalManage);
  }
  getUserDetails(token) {
    this.counter++;
    if(this.counter > this.max) {
      clearInterval(this.intervalManage);
      this.failed = true;
    }
   else {
    console.log('trying again');
    this.http.get('https://staging.videyo.tv/manage/wrapMeLogin?siteID='+this.siteID+'&token=' + token, {
    })
      .subscribe(
        data => {
          console.log('Login Via Customer ID')
          this.profileData = data['profile'];
          this.username = this.profileData['username'];
          this.tempPass = this.profileData['password'];
          console.log(data['profile']);
          if (data['profile'].length === 0) {
            console.log(data['setTryAgain']);
           if (this.tryAgain == false) {
            console.log(data['setTryAgainAgain']); 
            this.tryAgain = true;
            this.getUserDetailAgain();
           }
          }
          else {
            clearInterval(this.intervalManage);
            this.tryAgain = false;
            console.log('loginUser')
              this.newUserLogin();
          }
        },
        error => {

        }
      );
   }
  }
  newUserLogin() {
    var currentUser
    var baseUrl = "https://api-staging.videyo.tv"

    this.http.post(baseUrl + '/api/login', {
      'username': this.username,
      'password': this.tempPass
    }).subscribe(
      res => {
        localStorage.setItem('access_token', (res["access_token"]));
        if (window.location.pathname.indexOf('\/fr\/') > -1) {
          this.router.navigate(["/"]);
        }
        else if (window.location.pathname.indexOf('\/en\/') > -1) {
          this.router.navigate(["/"]);
        }
        else if (window.location.pathname.indexOf('\/ar\/') > -1) {
          this.router.navigate(["/"]);
        }
        else {
          console.log('Testing');
        }


      },
      err => {
      }
    );
    return false;
  }

  ngOnInit() {

    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.loaded = true;
    }, 1500);
  }

}
